import type { FetchErrorResponse } from "@anggunpraya-templates/types";
import type { FetchResponse } from "ofetch";

/**
 * Menangani response error dari request API shared.
 *
 * Utility ini mengambil pesan error dari payload API lalu melemparkannya kembali
 * sebagai `Error` biasa agar service/composable pemanggil bisa memakai flow error
 * yang lebih sederhana.
 *
 * @param options Opsi response error dari `ofetch`
 * @param options.response Response yang berisi payload error backend
 * @throws Error dengan message yang sudah dipilih dari payload response
 */
export function handleErrorResponse({
  response,
}: {
  response: FetchResponse<FetchErrorResponse>;
}) {
  const message
    = response._data?.error?.message
      || "Terjadi kesalahan saat melakukan permintaan.";

  console.error(message);
  throw new Error(message);
}
